/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ichbindamiteinverstandenindieteilnehmerlisteaufgenommenzuwerden9Inputs */

const en__field_ichbindamiteinverstandenindieteilnehmerlisteaufgenommenzuwerden9 = /** @type {(inputs: _Field_Ichbindamiteinverstandenindieteilnehmerlisteaufgenommenzuwerden9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I agree to be included in the participant list`)
};

const de__field_ichbindamiteinverstandenindieteilnehmerlisteaufgenommenzuwerden9 = /** @type {(inputs: _Field_Ichbindamiteinverstandenindieteilnehmerlisteaufgenommenzuwerden9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich bin damit einverstanden, in die Teilnehmerliste aufgenommen zu werden`)
};

/**
* | output |
* | --- |
* | "I agree to be included in the participant list" |
*
* @param {_Field_Ichbindamiteinverstandenindieteilnehmerlisteaufgenommenzuwerden9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_ichbindamiteinverstandenindieteilnehmerlisteaufgenommenzuwerden9 = /** @type {((inputs?: _Field_Ichbindamiteinverstandenindieteilnehmerlisteaufgenommenzuwerden9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ichbindamiteinverstandenindieteilnehmerlisteaufgenommenzuwerden9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_ichbindamiteinverstandenindieteilnehmerlisteaufgenommenzuwerden9(inputs)
	return de__field_ichbindamiteinverstandenindieteilnehmerlisteaufgenommenzuwerden9(inputs)
});
export { _field_ichbindamiteinverstandenindieteilnehmerlisteaufgenommenzuwerden9 as "_field_ichBinDamitEinverstandenInDieTeilnehmerlisteAufgenommenZuWerden" }